import { Icon } from '@factorialco/deprecated-design-system'
import { GetCommandBarTasksDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import type { ResultType, SearchPlugin, SearchPluginHook } from 'modules/command_bar/lib/types'

const useTasks: SearchPluginHook = (search) => {
  const { navigation } = useNavigation()
  const { access } = useCurrentSession()
  const { data, loading } = useQuery(GetCommandBarTasksDocument, {
    variables: {
      assigneeId: access.id,
      status: 'incompleted',
      search: search,
    },
  })

  function results() {
    if (!search.length) return []

    return (
      data?.tasks.tasks.map(
        (task): ResultType => ({
          id: task.id.toString(),
          text: task.name,
          IconComponent: () => <Icon.Medium icon="check-circle-line" />,
          type: 'navigation',
          score: 2,
          navigationPath: navigation.tasks.taskId.fullPath({ taskId: task.id }),
        })
      ) || []
    )
  }

  return {
    id: 'tasks',
    results: results(),
    title: i18n.t('command_bar.plugins.tasks.title'),
    loading,
  }
}

export const tasks: SearchPlugin = {
  hook: useTasks,
}
